import {
  DynamicZoneComponentDTO,
  StrapiDynamicZoneComponentDTO,
} from "@lib/strapi/dtos/core/dynamicZoneComponent.dto";
import { parseStrapiContent } from "@lib/strapi/content";
import { MDXRemoteSerializeResult } from "next-mdx-remote";

export interface StrapiTreatmentsSectionDTO
  extends StrapiDynamicZoneComponentDTO {
  heading: string;
  intro: string;
  layout: "Grid" | "Carousel";
  source: "All" | "HomepageCarousel";
  slugs: string;
}

export class TreatmentsSectionDTO extends DynamicZoneComponentDTO {
  constructor() {
    super();
  }

  heading: string;
  intro: MDXRemoteSerializeResult;
  layout: "Grid" | "Carousel";
  source: "All" | "HomepageCarousel";
  /** comma-separated treatment slugs — overrides source, defines order */
  slugs: string;
}
